import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MonitorDataComponent } from "./monitor-data.component";


const routes: Routes = [
  {
    path: '',
    component: MonitorDataComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MonitorDataRoutingModule { }
